import {API_URL} from "../URL";

const MAX_DESCRIPTION_IMAGE_SIZE = 45 * 1024 * 1024;

export function CustomUploadAdapterPlugin(editor) {
    const cardId = editor.config.get("customUploadAdapter.cardId");

    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
        return {
            upload: async () => {
                const file = await loader.file;

                // Comments still use the legacy Base64 flow until their API is
                // migrated. Description editors pass a card id and upload files
                // separately, keeping the description request small.
                if (cardId) {
                    if (file.size > MAX_DESCRIPTION_IMAGE_SIZE) {
                        throw new Error("The image must be 45 MB or smaller.");
                    }

                    const formData = new FormData();
                    formData.append("card_id", cardId);
                    formData.append("file", file, file.name || "description-image");

                    const response = await fetch(API_URL + "/post/upload_description_image/", {
                        method: "POST",
                        body: formData,
                    });
                    const data = await response.json().catch(() => ({}));

                    if (!response.ok || !data.url) {
                        throw new Error(data.error || data.detail || "Could not upload the image.");
                    }

                    return {default: data.url};
                }

                return new Promise((resolve, reject) => {
                    const reader = new FileReader();

                    reader.onload = () => {
                        resolve({
                            default: reader.result, // base64 image
                        });
                    };

                    reader.onerror = (error) => reject(error);

                    reader.readAsDataURL(file);
                });
            },
        };
    };
}
